<template>
  <StepLayout :without-left-template>
    <template #left>
      <RevIllustration
        alt=""
        class="rounded-lg hidden w-full min-w-[337px] max-w-[498px] md:block md:rounded-[32px]"
        :height="498"
        src="/img/tradein-apac/step-trade-in-au.jpg"
        :width="498"
      />
    </template>
    <template #right>
      <div class="flex flex-col">
        <h2 class="heading-1 mb-16">
          {{ i18n(translations.titleStep) }}
        </h2>
        <RevIllustration
          alt=""
          class="rounded-lg mb-24 block aspect-[3/2] w-full object-cover object-center md:hidden md:rounded-[32px]"
          :height="218"
          src="/img/tradein-apac/step-trade-in-au.jpg"
          :width="327"
        />
        <CardGuidance
          :clickable="true"
          data-qa="open-tradein-au-modal-button"
          data-test="open-tradein-au-modal-button"
          :icon="IconSwap"
          :label="i18n(translations.swapCardGuidance)"
          :modal-name="MODAL_NAMES.TRADEIN_AU"
        />
        <TradeInOffer
          v-if="acceptedOffer"
          class="mb-8"
          :name="acceptedOffer.productShortTitle"
          :price="acceptedOffer.price"
        />
        <TradeInModal :modal-name="MODAL_NAMES.TRADEIN_AU" />
      </div>
    </template>
  </StepLayout>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'
import { IconSwap } from '@ds/icons/IconSwap'

import CardGuidance from '~/scopes/product-core/components/presentationals/CustomizationFunnel/components/CardGuidance/CardGuidance.vue'
import StepLayout from '~/scopes/product-core/components/presentationals/CustomizationFunnel/components/StepLayout/StepLayout.vue'
import TradeInModal from '~/scopes/tradein-apac/components/TradeInModal/TradeInModal.vue'
import TradeInOffer from '~/scopes/tradein-apac/components/TradeInOffer/TradeInOffer.vue'
import { useTradeInApacOffer } from '~/scopes/tradein-apac/composables/useTradeInApacOffer'
import { MODAL_NAMES } from '~/scopes/tradein-apac/constants'

import translations from './Step.translations'

defineProps<{
  withoutLeftTemplate?: boolean
}>()

const i18n = useI18n()

const { acceptedOffer } = useTradeInApacOffer()
</script>
